import { render } from "./EduPage.vue?vue&type=template&id=13af6a4b&ts=true"
import script from "./EduPage.vue?vue&type=script&lang=ts"
export * from "./EduPage.vue?vue&type=script&lang=ts"

import "./EduPage.vue?vue&type=style&index=0&id=13af6a4b&lang=css"

import exportComponent from "P:\\roboworks\\easyros\\easyros\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__